import {ValueObject} from '@s-ui/domain'

export class MarketedYearValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {String} params.title
   * @param {String} params.url
   * @param {Bool} params.isSelected
   * */
}
